import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import ChevronDown from 'react-feather/dist/icons/chevron-down.js';
import ChevronUp from 'react-feather/dist/icons/chevron-up.js';
import Tooltip from 'rc-tooltip';

import './FilterOrder.scss';

export default class FilterOrder extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    ascValue: PropTypes.string,
    descValue: PropTypes.string,
    searchQuery: PropTypes.object,
  };

  static defaultProps = {
    className: '',
    ascValue: 'ASC',
    descValue: 'DESC',
    search: {}
  };

  constructor(props) {
    super(props);
    this.state = {
      up: props.searchQuery[props.name] === '' || props.searchQuery[props.name] === undefined ? null : props.searchQuery[props.name],
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.searchQuery && prevProps.searchQuery && this.props.searchQuery[this.props.name] !== prevProps.searchQuery[prevProps.name]) {
      this.setState({
        up: this.props.searchQuery[this.props.name] === '' || this.props.searchQuery[this.props.name] === undefined ? null : this.props.searchQuery[this.props.name],
      });
    }
  }

  onClick = () => {
    let value = null;
    if (this.state.up === null) {
      value = this.props.ascValue;
    } else if (this.state.up === this.props.ascValue) {
      value = this.props.descValue;
    }

    this.setState({ up: value });
    const search = {};
    search[this.props.name] = value;
    this.props.onChange(search);
  };

  render() {
    return (
      <Tooltip placement="bottom" overlay={this.props.tooltip}>
        <div className={`${this.props.className} filter-order`} onClick={this.onClick}>
          <div className={`label ${this.state.up === null ? '' : 'active'}`} >{this.props.label}</div>
          <div className="icon">
            <ChevronUp className={this.state.up === this.props.ascValue ? 'active' : ''} />
            <ChevronDown className={this.state.up === this.props.descValue ? 'active' : ''} />
          </div>
        </div>
      </Tooltip>
    )
  }
}